import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6930754c5a24100014d6bde6/finvion_landing_page/src/app/landing-page/components/LandingPageInteractive.tsx");
